<div class="unsupported-browser">
  <div class="unsupported-browser__card">
    <h1 class="unsupported-browser__title">Breeze</h1>
    <p class="unsupported-browser__message">
      Your browser isn't supported. Please use the latest version of one of these browsers to
      continue:
    </p>
    <ul class="unsupported-browser__list">
      <li *ngFor="let browser of browsers">
        <a [href]="browser.url" target="_blank" rel="noopener noreferrer">{{ browser.name }}</a>
      </li>
    </ul>
  </div>
</div>
